<template>
	<i ref="icon" class="dy-icon iconfont" :class="icon + ' ' + type" 
		@click="mouseClick" 
		@mouseout="mouseOut"
		@mouseenter="mouseOver">
		<slot></slot>
	</i>
</template>

<script>
	export default {
		name:"dy-icon",
		props:{
			icon:{
				type:String,
				default:'',
			},
			tooltip:{
				type:[Number, String],
				default:'',
			},
			type:{
				type:String,
				default:'bottom',
			},
			menu:{
				type:Object,
				default:null,
			},
			popup:{
				type:Boolean,
				default:false,
			},
		},
		data() {
			return {
				elem:null,
				elemMenu:null,
			};
		},
		methods:{
			mouseOut(e){
				if(!this.popup || !this.elemMenu) this.hide(e);
			},
			mouseOver(e, popup){
				let sw	 = document.body.offsetWidth;
				let sh	 = document.body.offsetHeight;
				let rect = this.$refs.icon.getBoundingClientRect();
				
				//提示
				if(this.tooltip && !this.elem){
					let elem = document.createElement('div');
					elem.classList.add('dy-tooltip');
					elem.innerHTML	= this.tooltip;
					document.body.appendChild(elem);
					
					let x	 = -elem.offsetWidth /2 + rect.width /2;
					let y	 = -elem.offsetHeight /2 + rect.height /2;
					
					if(rect.x + elem.offsetWidth > sw) x -= (rect.x + elem.offsetWidth -sw) /2;
					if(rect.y + rect.height + elem.offsetHeight > sh) {
						y -= elem.offsetHeight /2 + 15;
					} else {
						y += elem.offsetHeight /2 + 15;
					}
					
					elem.style.left		 = rect.x + 'px';
					if(this.type == 'bottom'){
						elem.style.top		= rect.y + 'px';
					}else{
						elem.style.top		= rect.y - elem.offsetHeight + 'px';
						y = rect.height / 2 - 10;
					}
					
					elem.style.transform = 'translate('+x+'px,'+y+'px)'; 	
					
					this.elem = elem;
				}				
				
				//菜单
				if((!this.popup || popup) && this.menu && !this.elemMenu){
					let elem = document.createElement('div');
					
					elem.classList.add('dy-icon-menu');
					
					for(let key in this.menu){
						let item = document.createElement('div');
						item.classList.add('dy-icon-menu-item');
						item.innerHTML = typeof(this.menu[key])=='object' ? this.menu[key].text : this.menu[key];
						
						item.addEventListener('click', e=>{this.clickMenu(key)}, {once:true});
						elem.appendChild(item);
					}
					
					if(!popup) {
						elem.addEventListener('mouseleave', this.hide, {once:true});
					} else {
						let mask = document.createElement('div');
						mask.classList.add('dy-menu-mask');
						mask.addEventListener('click', this.hide, {once:true});
						document.body.appendChild(mask);
						this.mask = mask;
					}
					
					document.body.appendChild(elem);
					
					let x	 = -elem.offsetWidth /2 + rect.width /2;
					let y	 = -elem.offsetHeight /2 + rect.height /2;
					
					if(rect.x + elem.offsetWidth > sw) x -= (rect.x + elem.offsetWidth -sw) /2;
					elem.style.left		 	= rect.x + 'px';
					
					if(this.type == 'bottom'){
						if(rect.y + rect.height + elem.offsetHeight > sh) {
							y -= elem.offsetHeight /2 + 10;
						} else {
							y += elem.offsetHeight /2 + 10;
						}
						elem.style.top		= rect.y + 'px';
					}else{
						if(elem.offsetHeight > rect.top){
							y = 0;
						}else{
							y += elem.offsetHeight /2 + 10;
						}
						elem.style.top = rect.y - elem.offsetHeight - y + 'px';
					}
					
					elem.style.transform 	= 'translate('+x+'px,'+y+'px)';
					
					this.elemMenu = elem;
				}
			},
			hide(e){
				this.elem && document.body.removeChild(this.elem);
				this.elem = null;
				
				//if(e.toElement.classList[0] && e.toElement.classList[0] != 'dy-icon-menu'){
				if(e.toElement != this.elemMenu){
					this.elemMenu && document.body.removeChild(this.elemMenu);
					this.elemMenu = null;
				}
				
				this.mask && document.body.removeChild(this.mask);
				this.mask = null;
			},
			mouseClick(e){
				//菜单
				if(this.menu){
					if(!this.elemMenu && this.popup){
						this.mouseOver(e, true);
					} else {
						this.hide(e)
					}
				} else {
					this.hide(e);
				}
				// this.elemMenu || this.elem ? this.hide(e) : this.mouseOver(e);
			},
			clickMenu(index){
				this.elem && document.body.removeChild(this.elem);
				this.elem = null;
				
				this.elemMenu && document.body.removeChild(this.elemMenu);
				this.elemMenu = null;
				
				this.mask && document.body.removeChild(this.mask);
				this.mask = null;
				
				this.$emit('menuClick', index);
			}
		}
	}
</script>

<style scoped>
.dy-icon{
	display: inline-block;
	font-size:12px;
	overflow: visible;
	min-height: 16px;
	white-space: nowrap;
}
.dy-icon:hover{
	/* color:#fff; */
}
.dy-icon:before{
	font-size:16px;
}
</style>